export function titleFromContent(htmlContent: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlContent || '', 'text/html')
  const title = doc.body.querySelector('p')?.innerText || ''
  
  // Remove dots, commas, and dashes from the end of the title
  return title.replace(/[.,\-]+$/, '')
}